import { BaseService } from "./BaseService";
import { ReservationService } from "./ReservationService";

export class SchoolService extends BaseService {
  reservationService = new ReservationService();

  constructor() {
    super("/schools");
  }

  async findByAvailability(weekday,strDate) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/weekday/${weekday}?date=${strDate}`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getSchoolsWithReservations() {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/real-time`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async enable(schoolId) {
    try {
      const response = await this.getClient().patch(
        `${this.baseUrl}/${schoolId}/enable`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async disable(schoolId) {
    try {
      const response = await this.getClient().delete(
        `${this.baseUrl}/${schoolId}/disable`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async toggleAllSchoolsStatus(active) {
    try {
      const response = await this.getClient().patch(
        `${this.baseUrl}/toggle-all-status`,
        { active }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getSchoolById(schoolId) {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/${schoolId}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getSchoolWithUsage(schoolId) {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/${schoolId}/with-usage`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getEventReservationsByDay(schoolId) {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/${schoolId}/reservations-by-day`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  // 🚀 FIXED: Delegating Reservation Methods to ReservationService
  async addReservation(reservation) {
    return this.reservationService.addReservation(reservation);
  }

  async getReservations() {
    return this.reservationService.getReservations();
  }

  async getReservationHistory() {
    return this.reservationService.getReservationHistory();
  }
}
